// extracted by mini-css-extract-plugin
module.exports = {"coins":"hpETs6","coin":"oUDgQh","coinData":"VB1l6s","iconContainer":"ynWrlo","clickable":"AzovaM"};